<app-loader-circles *ngIf="isBuscandoCep"></app-loader-circles>

<form [formGroup]="currentForm" class="forms">
  <div class="form-group">
    <span class="icon {{ tipoEndereco }}"></span>
    <div class="inputs">
      <label for="cep" class="text-capitalize">Endereço {{ tipoEndereco }} CEP</label>
      <input
        class="form-control"
        type="text"
        placeholder="Digite o CEP do endereço..."
        mask-number
        mask="99999-999"
        [minLength]="8"
        [maxLength]="9"
        required
        appOnlyDigitsLengthValidator
        appShowErrorMessages
        requiredMessage="O campo Endereço {{ tipoEndereco }} CEP é obrigatório"
        name="cep"
        formControlName="cep"
        appOnlyNumberRestrictive
        [readonly]="disabled"
      />
      <a
        title="Consultar site dos correios"
        target="_blank"
        href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
        rel="noopener"
        >Não sabe o CEP?</a
      >
    </div>
  </div>

  <div class="form-group">
    <span class="icon vazio"></span>
    <div class="inputs">
      <label for="logradouro">Endereço</label>
      <input
        class="form-control"
        type="text"
        placeholder="Rua, Avenida, Alameda e etc..."
        maxlength="100"
        required
        appShowErrorMessages
        requiredMessage="O campo Endereço é obrigatório"
        name="logradouro"
        formControlName="logradouro"
        appOnlyNumberOrCharacterWhiteSpace
      />
    </div>
  </div>

  <div class="form-group">
    <span class="icon vazio"></span>
    <div class="inputs d-flex">
      <div class="small-inputs">
        <label for="numero">Número</label>
        <input
          class="form-control"
          type="text"
          placeholder="Ex.: 123"
          maxlength="9"
          required
          appShowErrorMessages
          requiredMessage="O campo Número é obrigatório"
          name="numero"
          formControlName="numero"
          appOnlyNumberRestrictive
        />
      </div>

      <div class="big-inputs">
        <label for="complemento">Complemento</label>
        <input
          class="form-control"
          type="text"
          placeholder="Apartamento, Bloco e etc..."
          name="complemento"
          formControlName="complemento"
          maxlength="20"
        />
      </div>
    </div>
  </div>

  <div class="form-group">
    <span class="icon vazio"></span>
    <div class="inputs">
      <label for="bairro">Bairro</label>
      <input
        class="form-control"
        type="text"
        placeholder="Digite o bairro..."
        maxlength="60"
        required
        appShowErrorMessages
        requiredMessage="O campo Bairro é obrigatório"
        name="bairro"
        formControlName="bairro"
      />
    </div>
  </div>

  <div class="form-group">
    <span class="icon vazio"></span>
    <div class="inputs d-flex">
      <div class="small-inputs">
        <label for="uf">UF</label>
        <input
          type="text"
          class="form-control"
          required
          appShowErrorMessages
          requiredMessage="O campo UF é obrigatório"
          name="uf"
          formControlName="uf"
          placeholder="Selecione..."
        />
      </div>

      <div class="big-inputs">
        <label for="cidade">Cidade</label>
        <input
          type="text"
          placeholder="Selecione..."
          class="form-control"
          required
          appShowErrorMessages
          requiredMessage="O campo Cidade é obrigatório"
          name="cidade"
          formControlName="cidade"
        />
      </div>
    </div>
  </div>
</form>

<app-new-modal-message
  #cepInvalidoModal
  [showFecharBtn]="false"
></app-new-modal-message>
